import React from 'react';
import { Link, Redirect } from "react-router-dom";
import {
	Card,
	Row,
	Col,
	Form,
	Input,
	InputNumber,
	Button,
	message,
	Alert,
	Divider,
	Typography,
} from 'antd';
import {
	DiffOutlined,
	SaveOutlined,
	CloseCircleOutlined,
	ClusterOutlined,
	TagOutlined,
	NumberOutlined,
	BankOutlined,
	ArrowLeftOutlined,
	EditOutlined,
	PlusCircleOutlined,
	FontSizeOutlined,
} from '@ant-design/icons';
import moment from 'moment';

import Config from '../../Config';

import { connect } from 'react-redux';
import {
	initHandler,
	ajaxViewHandler,
	ajaxHandler,
	setConfig,
	extractResult,
} from "../../store/actions";
import { Helmet } from "react-helmet";
import ErrorAlertModal from '../../components/ErrorAlertModal';

const { Text } = Typography;

const configClass = {
	apiUrl: { preview: "master/api/jenis/kendaraan/" },
	pageUrl: { data: '/admin/jenis-kendaraan/' },
};

const config = new Config();

const FIELD_STYLE = { borderRadius: 8, height: 38 };

const SectionHeader = ({ icon, title }) => (
	<div style={{
		padding: '12px 24px',
		background: 'linear-gradient(135deg, #0f284711, #1e4d8a11)',
		borderBottom: '1.5px solid #d0dff5',
		borderTop: '1px solid #f0f0f0',
		display: 'flex', alignItems: 'center', gap: 10,
	}}>
		<span style={{ color: '#1e4d8a', fontSize: 15 }}>{icon}</span>
		<Text strong style={{ fontSize: 14, color: '#0f2847' }}>{title}</Text>
	</div>
);

class FormJenisKendaraan extends React.Component {
	formRef = React.createRef();

	constructor(props) {
		super(props);
		this.state = {
			errComponent: false,
			errTitle: '',
			errMsg: '',
			loadingButton: false,
			aksi: 'tambah',
			method: 'post',
			idLama: '',
			isMobile: window.innerWidth <= 768,
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		if (this.props.match.params.id != undefined) {
			this.preview(this.props.match.params.id);
		}
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	async preview(id) {
		message.loading({ content: 'Memuat data...', duration: 0, key: 'toast' });
		this.props.ajaxViewHandler('get', configClass.apiUrl.preview + id)
			.then((action) => {
				const { isSuccess, responseMsg: data } = extractResult(action);
				if (isSuccess) {
					this.formRef.current.setFieldsValue(data);
					for (var key in data) {
						const dateRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4}$/;
						const dateTimeRegex = /^[0-9]{2}\-[0-9]{2}\-[0-9]{4} [0-9]{2}\:[0-9]{2}\:[0-9]{2}$/;
						if (dateRegex.test(data[key])) {
							this.formRef.current.setFieldsValue({ [key + '_picker']: moment(data[key], 'DD-MM-YYYY') });
						} else if (dateTimeRegex.test(data[key])) {
							this.formRef.current.setFieldsValue({ [key + '_picker']: moment(data[key], 'DD-MM-YYYY HH:mm:ss') });
						}
					}
					message.destroy();
					this.setState({ aksi: 'edit', method: 'put', idLama: id + '/' });
				} else {
					const errTitle = 'Gagal memuat data';
					this.setState({ errTitle, errMsg: data });
					message.error({ content: errTitle, duration: 2, key: 'toast' });
				}
			})
			.catch(() => {
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	handleSubmit = (values) => {
		this.postData(values);
	}

	async postData(datas) {
		message.loading({ content: 'Menyimpan...', key: 'toast' });
		this.props.ajaxHandler(this.state.method, configClass.apiUrl.preview + this.state.idLama, datas, false, true)
			.then((action) => {
				this.setState({ loadingButton: false });
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) {
					message.success({ content: 'Data berhasil disimpan', duration: 2, key: 'toast' });
				} else {
					const errTitle = 'Gagal menyimpan data';
					message.error({ content: errTitle, duration: 2, key: 'toast' });
					this.setState({ errTitle, errMsg: responseMsg });
				}
			})
			.catch(() => {
				this.setState({ loadingButton: false });
				message.error({ content: 'Kesalahan pengiriman data, coba lagi', duration: 2, key: 'toast' });
			});
	}

	render() {
		if (this.props.isRedirect) {
			return <Redirect to={configClass.pageUrl.data} />;
		}

		const { isMobile, aksi, errMsg, errTitle, loadingButton, errComponent } = this.state;
		const isEdit = aksi === 'edit';
		const pageTitle = isEdit ? 'Edit Jenis Kendaraan' : 'Tambah Jenis Kendaraan';
		const colSpan = isMobile ? 24 : 12;

		return (
			<div>
				<Helmet>
					<title>{pageTitle + ' | ' + config.get_site_info().name}</title>
					<style>{`
						.form-jenis-wrap .ant-form-item-label > label {
							font-weight: 600;
							color: #374151;
							font-size: 13px;
						}
						.form-jenis-wrap .ant-input:focus,
						.form-jenis-wrap .ant-input-number-focused {
							border-color: #1e4d8a !important;
							box-shadow: 0 0 0 2px rgba(30,77,138,0.1) !important;
						}
					`}</style>
				</Helmet>


				<ErrorAlertModal
					visible={errMsg !== ''}
					title={errTitle}
					error={errMsg}
					onClose={() => this.setState({ errTitle: '', errMsg: '' })}
				/>

				<Form
					layout="vertical"
					name="fdata"
					onFinish={this.handleSubmit}
					ref={this.formRef}
					className="form-jenis-wrap"
				>
					<Card
						style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden' }}
						bodyStyle={{ padding: 0 }}
					>
						{/* ── Header ── */}
						<div style={{
							background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
							padding: '20px 24px',
							display: 'flex', alignItems: 'center', gap: 16,
						}}>
							<div style={{
								width: 52, height: 52, borderRadius: 14,
								background: 'rgba(255,255,255,0.15)',
								display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
							}}>
								{isEdit
									? <EditOutlined style={{ color: '#fff', fontSize: 24 }} />
									: <PlusCircleOutlined style={{ color: '#fff', fontSize: 24 }} />
								}
							</div>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ color: '#fff', fontWeight: 700, fontSize: 18, lineHeight: 1.3 }}>
									{pageTitle}
								</div>
								<div style={{ color: 'rgba(255,255,255,0.65)', fontSize: 13, marginTop: 3 }}>
									{isEdit
										? 'Ubah informasi jenis kendaraan'
										: 'Isi formulir untuk menambah jenis kendaraan baru'
									}
								</div>
							</div>
							<Link to={configClass.pageUrl.data}>
								<Button
									icon={<ArrowLeftOutlined />}
									style={{ background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff', borderRadius: 8 }}
								>
									{!isMobile && 'Kembali'}
								</Button>
							</Link>
						</div>

						{/* ── Section 1: Data Dasar ── */}
						<SectionHeader icon={<ClusterOutlined />} title="Data Dasar" />
						<div style={{ padding: '20px 24px' }}>
							<Row gutter={[16, 0]}>
								<Col span={24}>
									<Form.Item
										label={<span><ClusterOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Nama Jenis Kendaraan</span>}
										name="nama"
										rules={[{ required: true, message: 'Nama harus diisi' }]}
									>
										<Input placeholder="Contoh: Sedan, SUV, Motor, Truk..." style={FIELD_STYLE} />
									</Form.Item>
								</Col>
								<Col xs={24} md={8}>
									<Form.Item
										label={<span><TagOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Kode</span>}
										name="kode"
										rules={[{ required: true, message: 'Kode harus diisi' }]}
									>
										<Input placeholder="Contoh: SED, SUV..." style={FIELD_STYLE} />
									</Form.Item>
								</Col>
								<Col xs={24} md={8}>
									<Form.Item
										label={<span><FontSizeOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Kode Huruf</span>}
										name="huruf"
										rules={[{ required: true, message: 'Huruf harus diisi' }]}
									>
										<Input placeholder="Contoh: A, B, C..." style={FIELD_STYLE} />
									</Form.Item>
								</Col>
								<Col xs={24} md={8}>
									<Form.Item
										label={<span><NumberOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Jumlah Roda</span>}
										name="roda"
										rules={[{ required: true, message: 'Roda harus diisi' }]}
									>
										<Input placeholder="Contoh: 2, 4, 6..." style={FIELD_STYLE} />
									</Form.Item>
								</Col>
								<Col span={24}>
									<Form.Item
										label={<span><NumberOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />Plat Kuning (dalam persen)</span>}
										name="plat_kuning"
										rules={[{ required: true, message: 'Plat kuning harus diisi' }]}
										style={{ marginBottom: 0 }}
									>
										<InputNumber
											min={0}
											step={0.1}
											decimalSeparator="."
											placeholder="Contoh: 0, 0.5, 1..."
											style={{ width: '100%', borderRadius: 8, height: 38 }}
										/>
									</Form.Item>
								</Col>
							</Row>
						</div>

						{/* ── Section 2: Nomor Rekening ── */}
						<SectionHeader icon={<BankOutlined />} title="Nomor Rekening" />
						<div style={{ padding: '20px 24px' }}>
							<Row gutter={[16, 0]}>
								<Col xs={24} md={colSpan}>
									<Form.Item
										label={<span><BankOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />No. Rek. BBNKB</span>}
										name="akun_bbnkb"
										rules={[{ required: true, message: 'Harus diisi' }]}
									>
										<Input placeholder="Nomor rekening BBNKB" style={FIELD_STYLE} />
									</Form.Item>
								</Col>
								<Col xs={24} md={colSpan}>
									<Form.Item
										label={<span><BankOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />No. Rek. Denda BBNKB</span>}
										name="akun_denda_bbnkb"
										rules={[{ required: true, message: 'Harus diisi' }]}
									>
										<Input placeholder="Nomor rekening denda BBNKB" style={FIELD_STYLE} />
									</Form.Item>
								</Col>
								<Col xs={24} md={colSpan}>
									<Form.Item
										label={<span><BankOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />No. Rek. PKB</span>}
										name="akun_pkb"
										rules={[{ required: true, message: 'Harus diisi' }]}
									>
										<Input placeholder="Nomor rekening PKB" style={FIELD_STYLE} />
									</Form.Item>
								</Col>
								<Col xs={24} md={colSpan}>
									<Form.Item
										label={<span><BankOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />No. Rek. Denda PKB</span>}
										name="akun_denda_pkb"
										rules={[{ required: true, message: 'Harus diisi' }]}
									>
										<Input placeholder="Nomor rekening denda PKB" style={FIELD_STYLE} />
									</Form.Item>
								</Col>
								<Col xs={24} md={colSpan}>
									<Form.Item
										label={<span><BankOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />No. Rek. SP3</span>}
										name="akun_sp3"
										rules={[{ required: true, message: 'Harus diisi' }]}
									>
										<Input placeholder="Contoh: 4.3.3.01.01.01" style={FIELD_STYLE} />
									</Form.Item>
								</Col>
								<Col xs={24} md={colSpan}>
									<Form.Item
										label={<span><BankOutlined style={{ color: '#1e4d8a', marginRight: 6 }} />No. Rek. SP3 Mutasi</span>}
										name="akun_sp3_mutasi"
										rules={[{ required: true, message: 'Harus diisi' }]}
										style={{ marginBottom: 0 }}
									>
										<Input placeholder="Contoh: 4.3.3.01.01.04" style={FIELD_STYLE} />
									</Form.Item>
								</Col>
							</Row>
						</div>

						{/* ── Footer tombol ── */}
						<Divider style={{ margin: 0 }} />
						<div style={{
							padding: '16px 28px',
							display: 'flex',
							gap: 10,
							justifyContent: isMobile ? 'stretch' : 'flex-end',
							flexDirection: isMobile ? 'column' : 'row',
							background: '#fafafa',
						}}>
							<Link to={configClass.pageUrl.data} style={isMobile ? { display: 'block' } : {}}>
								<Button
									icon={<CloseCircleOutlined />}
									size="large"
									disabled={loadingButton}
									style={{ borderRadius: 10, ...(isMobile ? { width: '100%' } : {}) }}
								>
									Batal
								</Button>
							</Link>
							<Button
								type="primary"
								htmlType="submit"
								icon={<SaveOutlined />}
								size="large"
								loading={loadingButton}
								disabled={errComponent}
								style={{
									borderRadius: 10,
									background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
									border: 'none',
									fontWeight: 600,
									...(isMobile ? { width: '100%' } : {}),
								}}
							>
								{isEdit ? 'Simpan Perubahan' : 'Tambah Jenis Kendaraan'}
							</Button>
						</div>
					</Card>
				</Form>
			</div>
		);
	}
}

const mapStateToProps = function (state) { return state.configReducers; }

export default connect(mapStateToProps, { initHandler, setConfig, ajaxViewHandler, ajaxHandler })(FormJenisKendaraan);
